import { IAssessmentQuestionApiResponse, IAssessmentQuestionType } from '@sondermind/utilities/models-assessments';

export const GET_QUESTION_RESPONSE: IAssessmentQuestionApiResponse = {
  currentIndex: 0,
  isLastQuestion: false,
  question: {
    questionId: 'q1',
    text: 'How often do you have a drink containing alcohol?',
    type: IAssessmentQuestionType.MULTIPLE_CHOICE,
    options: ['Never', 'Monthly or less', '2-4 times a month', '2-3 times a week', '4 or more times a week']
  },
  totalQuestions: 3
};
